module.exports = __webpack_public_path__ + "img/3-3.a0cb2562.jpg";